import React, { useCallback, useState, useEffect } from "react";
import { Grid, Box, Typography, Card, IconButton, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from "../../../global/imagenes/emma_w.png";
import { useTendencias } from "../hooks/useTendencias";
import { getCompetenciasAlertas } from "../services/alertasGenericasService";
import FiltrosTendencias from "../components/Tendencias/FiltrosTendencias";
import TarjetasTendencias from "../components/Tendencias/TarjetasTendencias";
import GraficaEvolucionEstudiante from "../components/Tendencias/GraficaEvolucionEstudiante";
import GraficaRadarCompetencias from "../components/Tendencias/GraficaRadarCompetencias";
import TablaHistoricoPruebas from "../components/Tendencias/TablaHistoricoPruebas";
import RecomendacionesTendencias from "../components/Tendencias/RecomendacionesTendencias";
import ModalDetalleEstudiante from "../components/Tendencias/ModalDetalleEstudiante";

const Tendencias = () => {
  const [modalDetalleAbierto, setModalDetalleAbierto] = useState(false);
  const [filtroCompetencia, setFiltroCompetencia] = useState("RC");
  const [opcionesCompetencia, setOpcionesCompetencia] = useState([]);

  const {
    filtroAnio,
    setFiltroAnio,
    filtroSemestre,
    setFiltroSemestre,
    filtroPrueba,
    setFiltroPrueba,
    correo,
    setCorreo,
    opcionesAnio,
    opcionesSemestre,
    opcionesCorreo,
    opcionesPrueba,
    filasOrdenadas,
    metricas,
    recomendaciones,
    loadingEstudiante,
    cargandoVistaCompleta,
    tieneHistorialEstudiante,
    personaDetalle,
    evolucionAnualCompleta,
  } = useTendencias(filtroCompetencia);

  const onCorreoCommitted = useCallback((c) => {
    setCorreo(c);
  }, [setCorreo]);

  useEffect(() => {
    let activo = true;
    getCompetenciasAlertas().then((lista) => {
      if (!activo) return;
      setOpcionesCompetencia(lista);
    });
    return () => {
      activo = false;
    };
  }, []);

  useEffect(() => {
    setModalDetalleAbierto(false);
  }, [correo]);

  const tieneDatos = Boolean(correo && filasOrdenadas.length);

  const detalleModal = personaDetalle || {
    nombreCompleto: "",
    programa: "",
    correo_personal: "",
    telefono: "",
    celular: "",
    correo: correo || "",
  };

  const alturaGrafico = 168;

  return (
    <Box pb={0.5} pt={0.25} style={{ maxWidth: 1360, margin: "0 auto", paddingLeft: 12, paddingRight: 12 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        style={{ gap: 10, marginBottom: 8 }}
      >
        <Typography variant="h6" component="h1" style={{ fontWeight: 800, color: "#0f172a", margin: 0 }}>
          Tendencias de desempeño
        </Typography>

        {correo ? (
          <Card
            elevation={2}
            style={{
              borderRadius: 12,
              padding: "10px 14px 10px 18px",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              background: "#ffffff",
              boxShadow: "0 1px 8px rgba(0, 0, 0, 0.08)",
              maxWidth: "min(100%, 520px)",
              flexShrink: 0,
              marginLeft: "auto",
            }}
          >
            <Typography
              variant="h6"
              component="span"
              style={{
                fontWeight: 800,
                textTransform: "uppercase",
                letterSpacing: 0.4,
                color: "#0f172a",
                lineHeight: 1.25,
                fontSize: "1.05rem",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={loadingEstudiante ? "" : (personaDetalle?.nombreCompleto || "—").toUpperCase()}
            >
              {loadingEstudiante ? "…" : (personaDetalle?.nombreCompleto || "—").toUpperCase()}
            </Typography>
            <Tooltip title="Información de contacto">
              <span>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => setModalDetalleAbierto(true)}
                  aria-label="Ver información de contacto del estudiante"
                  style={{ padding: 6 }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </Card>
        ) : null}
      </Box>

      <Box mb={1}>
        <FiltrosTendencias
          filtroAnio={filtroAnio}
          filtroSemestre={filtroSemestre}
          filtroPrueba={filtroPrueba}
          correo={correo}
          onCorreoCommitted={onCorreoCommitted}
          opcionesAnio={opcionesAnio}
          opcionesSemestre={opcionesSemestre}
          opcionesCorreo={opcionesCorreo}
          opcionesPrueba={opcionesPrueba}
          filtrosDesactivados={!correo || loadingEstudiante || !tieneHistorialEstudiante}
          filtroCompetencia={filtroCompetencia}
          opcionesCompetencia={opcionesCompetencia}
          onCompetenciaChange={setFiltroCompetencia}
          onAnioChange={(v) => {
            setFiltroAnio(v);
            setFiltroSemestre("");
            setFiltroPrueba("");
          }}
          onSemestreChange={(v) => {
            setFiltroSemestre(v);
            setFiltroPrueba("");
          }}
          onPruebaChange={setFiltroPrueba}
        />
      </Box>

      <ModalDetalleEstudiante
        open={modalDetalleAbierto}
        onClose={() => setModalDetalleAbierto(false)}
        detalle={detalleModal}
        cargando={loadingEstudiante}
      />

      <Box position="relative" style={{ minHeight: cargandoVistaCompleta ? 320 : undefined }}>
        {cargandoVistaCompleta ? (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={8}
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{
              background: "#ffffff",
              borderRadius: 12,
            }}
          >
            <TareasTerminadas
              mensaje="Cargando datos del estudiante"
              imagen={emma_w}
              widthImg="7%"
              marginTop="0"
              width="min(100%, 320px)"
              cargando
            />
          </Box>
        ) : null}

        <Box mb={0.5} style={{ opacity: cargandoVistaCompleta ? 0.35 : 1, pointerEvents: cargandoVistaCompleta ? "none" : "auto" }}>
          <TarjetasTendencias metricas={metricas} tieneDatos={tieneDatos} />
        </Box>

        <Grid container spacing={1} alignItems="flex-start" style={{ opacity: cargandoVistaCompleta ? 0.35 : 1, pointerEvents: cargandoVistaCompleta ? "none" : "auto" }}>
          <Grid item xs={12} md={6}>
            <GraficaEvolucionEstudiante data={evolucionAnualCompleta} height={alturaGrafico} />
            <Box mt={0.5}>
              <RecomendacionesTendencias correo={correo} desemp={recomendaciones.desemp} cuc={recomendaciones.cuc} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box mb={0.5}>
              <GraficaRadarCompetencias data={metricas.radar} height={alturaGrafico + 28} />
            </Box>
            <TablaHistoricoPruebas filas={filasOrdenadas} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Tendencias;
